export const PAYMENT_STATUS_REQUEST = 'PAYMENT_STATUS_REQUEST';
export const PAYMENT_STATUS_SUCCESS = 'PAYMENT_STATUS_SUCCESS';
export const PAYMENT_STATUS_FAILURE = 'PAYMENT_STATUS_FAILURE';
